import { render, staticRenderFns } from "./ProfileFields.vue?vue&type=template&id=70acd3ee&scoped=true"
import script from "./ProfileFields.vue?vue&type=script&lang=js"
export * from "./ProfileFields.vue?vue&type=script&lang=js"
import style0 from "./ProfileFields.vue?vue&type=style&index=0&id=70acd3ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70acd3ee",
  null
  
)

export default component.exports